import { t } from 'i18next';
import { supportsBackgroundProcessors } from 'features/VirtualBackground/source';
import { AssetsControllerService } from 'api';
import { virtualBackgroundStore } from 'features/VirtualBackground/state/store/virtualBackground';
import { BLUR_RADIUS, LIGHT_BLUR_RADIUS } from '../constants';
import { PROCESSOR_TYPES } from '../types';
import { mapBackgroundsManifest } from '../utils/mapBackgroundsManifest';

const BACKGROUNDS_ASSET_KEY = 'vcs-backgrounds';

export const initBackgroundProcessor = async () => {
    if (!supportsBackgroundProcessors()) {
        console.error('this browser does not support background processors');
        virtualBackgroundStore.isVirtualBackgroundEnabled = false;
        return;
    }

    virtualBackgroundStore.setIsVirtualBackgroundEnabled(true);
};

export const setupBaseVirtualBackgrounds = () => {
    virtualBackgroundStore.addAvailableProcessor('none', { type: PROCESSOR_TYPES.none, text: t('web_button_no') });
    virtualBackgroundStore.addAvailableProcessor('lightBlur', {
        type: PROCESSOR_TYPES.blur,
        blurRadius: LIGHT_BLUR_RADIUS,
        text: t('videoconference_light_blur'),
    });
    virtualBackgroundStore.addAvailableProcessor('blur', {
        type: PROCESSOR_TYPES.blur,
        blurRadius: BLUR_RADIUS,
        text: t('videoconference_blur'),
    });
};

export const loadVirtualBackgrounds = async () => {
    try {
        // Получаем URL манифеста
        const { payload: { url: manifestUrl } = {}, error } = await AssetsControllerService.findAssetNonEncrypted({
            key: BACKGROUNDS_ASSET_KEY,
        });
        if (error || !manifestUrl) {
            console.error('Failed to fetch backgrounds manifest url');
            return;
        }

        // Загружаем манифест
        const manifestResponse = await fetch(manifestUrl);
        if (!manifestResponse.ok) {
            console.error('Failed to fetch backgrounds manifest file');
            return;
        }

        // Вырезаем из ссылки перву часть. Это будет префикс для картинок.
        // Сделано по общей договорённости с платформами.
        const prefix = manifestUrl.split('/').slice(0, -1).join('/') + '/';

        // Маппим манифест в нужный формат
        const rawManifest = await manifestResponse.json();
        const backgrounds = mapBackgroundsManifest(rawManifest, prefix);

        virtualBackgroundStore.appendAvailableProcessors(backgrounds);
    } catch (e) {
        console.error('Failed to load backgrounds', e);
    }
};

export const setupVirtualBackgrounds = async () => {
    initBackgroundProcessor();
    setupBaseVirtualBackgrounds();
    await loadVirtualBackgrounds();
};
